<template>
  <div class="gear-setup row">
    <div class="col-md-6 col-sm-12 mb-2">
      <div class="card compare-container">
        <div class="card-body shadow-inner">
          <div class="row">
            <div class="col-12">
              <InventoryContainer @spellbookChange="setSpellbook" @stanceChange="setStance" @spellChange="setSpell"
                                  @settingsChange="setSetting"
                                  @equipmentChanged="setEquipment" @update="save" @setClone="setClone"
                                  @loadPreset="loadPreset"
                                  :setup="setup" :player="player" :boosts="this.boosts"></InventoryContainer>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-sm-12 mb-2">
      <div class="card compare-container">
        <div class="card-body shadow-inner">
          <div class="row">
            <div class="col-12">
              <!--              <EquipmentBonusTable :equipment="setup.equipment"></EquipmentBonusTable>-->
              <MonsterBonus :monster="monster"></MonsterBonus>
              <hr>
              <EquipmentBonus :equipment="setup.equipment"></EquipmentBonus>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import GearPreview from "./GearPreview";
  import EquipmentBonus from "./EquipmentBonus";
  import StanceSelector from "./StanceSelector";
  import GearSetup from "./GearSetup";
  import PotionContainer from "./PotionContainer";
  import InventoryContainer from "../InventoryContainer";
  import EquipmentBonusTable from "./EquipmentBonusTable";
  import MonsterBonus from "./MonsterBonus";

  export default {
    name: "GearSetup",
    components: {
      MonsterBonus,
      EquipmentBonusTable,
      InventoryContainer, PotionContainer, GearSetup, StanceSelector, EquipmentBonus, GearPreview
    },
    props: {
      setup: {
        type: Object,
        required: true,
      },
      player: {
        type: Object,
        required: true,
      },
      monster: {
        type: Object,
      }
    },
    computed: {
      boosts: function () {
        return {
          attack: this.activeAttackBoost(),
          strength: this.activeStrengthBoost(),
          ranged: this.activeRangeBoost(),
          magic: this.activeMagicBoost(),
        }
      },
    },
    methods: {
      update: function (slot, item) {
        this.setup.equipment[slot] = item;
        this.save();
      },
      setStance: function (stance) {
        this.setup.activeStance = stance;

        if (stance.attack_style !== 'magic')
          this.setup.activeSpell = null;

        this.save();
      },
      setSpellbook: function (spellbook) {
        console.log('spellbookSwap', spellbook);

        this.setup.activeSpellbook = spellbook;
      },
      setEquipment: function (equipment) {
        this.setup.equipment = equipment;
        this.save();
      },
      setBoosts: function (potions) {
        this.setup.potions = potions;
        this.save();
      },
      setSetting: function (setting) {
        this.setup.settings[setting] = !this.setup.settings[setting];
        this.save();
      },
      setSpell: function (spell) {
        this.setup.activeSpell = spell;
        this.save();
      },

      loadPreset: function (set) {
        this.setup = set;
        this.save();
      },

      setClone: function () {
        this.$emit('setClone')
      },

      save: function () {
        this.$emit('update', this.setup)
      },

      /**
       * BOOST LOGIC BELOW
       */
      activeAttackBoost: function () {
        let lvl = this.player.attack.level;
        let boost = 0;

        // console.log(atkLvl, atkLvl * 0.15 + 5, this.selectedPotions.attack.id);

        switch (this.setup.potions.attack.id) {
          case 121: //Atk Pot
            boost = this.calculateBoost(lvl, 'basic');
            break;

          case 2436: //Super
          case 23697: //Divine
            boost = this.calculateBoost(lvl, 'super');
            break;

          case 11730: //Overload
            boost = this.calculateBoost(lvl, 'overload');
            break;
        }

        return Math.floor(boost);
      },

      activeStrengthBoost: function () {
        let lvl = this.player.strength.level;
        let boost = 0;

        // console.log(atkLvl, atkLvl * 0.15 + 5, this.selectedPotions.attack.id);

        switch (this.setup.potions.strength.id) {
          case 113: //Str Pot
            boost = this.calculateBoost(lvl, 'basic');
            break;

          case 2440: //Super
          case 23709: //Divine
            boost = this.calculateBoost(lvl, 'super');
            break;

          case 11730: //Overload
            boost = this.calculateBoost(lvl, 'overload');
            break;
        }

        return Math.floor(boost);
      },

      activeMagicBoost: function () {
        let lvl = this.player.magic.level;
        let boost = 0;

        switch (this.setup.potions.magic.id) {
          case 1907: //Wizard mind bomb
            boost = lvl > 50 ? 3 : 4;
            break;

          case 9763: //Magic cape
            boost = 1;
            break;

          case 3040: //Basic Pot
          case 23745: //Divine
          case 22449: //Battlemage
            boost = 4; //Magic is static boost
            break;

          case 16152: //Super
            boost = this.calculateBoost(lvl, 'super');
            break;

          case 11730: //Overload
            boost = this.calculateBoost(lvl, 'overload');
            break;

          case 20724: //Imbued Heart:
            boost = lvl * 0.1 + 1;
            break;
        }

        return Math.floor(boost);
      },

      activeRangeBoost: function () {
        let lvl = this.player.ranged.level;
        let boost = 0;

        // console.log('rangedBoost', lvl, this.setup.potions.ranged.id);

        switch (this.setup.potions.ranged.id) {
          case 9757: //Ranging cape
            boost = 1;
            break;

          case 7208: //Wild pie
            boost = 4;
            break;

          case 169: //Ranging pot
            boost = this.calculateBoost(lvl, 'basic'); //TODO check
            break;

          case 23733: //Devine
          case 22461: //Bastion
            boost = lvl * 0.1 + 4;
            break;

          case 11722: //Super
            boost = this.calculateBoost(lvl, 'super');
            break;

          case 11730: //Overload
            boost = this.calculateBoost(lvl, 'overload');
            break;
        }

        // console.log(boost);
        return Math.floor(boost);
      },
      calculateBoost(level, potionType) {
        switch (potionType) {
          case 'basic':
            return level * 0.1 + 3;
          case 'super':
            return (level * 0.15) + 5;
          case 'overload':
            return level * 0.16 + 6;
        }
      }

      /**
       * BOOST LOGIC FINISH
       */
    }
  }
</script>

<style scoped>
  .gear-setup {
    height: 100%;
  }

  .compare-container {
    height: 100%;
    min-height: 510px;
  }

  .compare-container > .card-body {
    padding-top: 0;
  }

  @media (min-width: 768px) {
    .compare-container {
      height: 100%;
      min-height: 510px;
    }
  }

  @media (min-width: 992px) {
    .compare-container {
      min-height: 600px;
    }
  }

  /*@media (min-width: 1200px) {*/
  /*  .compare-container {*/
  /*    min-height: 600px;*/
  /*  }*/
  /*}*/

  @media (min-width: 2560px) {
    .compare-container {
      min-height: 780px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/gear-selector/GearSetup.vue